import React from "react";
import { string } from "prop-types";
import { VFinder } from "./VFinder";

const VacationFinderConnector = ({ locale }) => {
	const language = locale && locale.split("-")[0];

	/* Setup the app config settings */
	const vfConfig = {
		options: {
			devMode: false,
			videoDemo: false,
		},
	};

	return <VFinder language={language} config={vfConfig} />;
};

VacationFinderConnector.propTypes = {
	locale: string.isRequired,
};

export default VacationFinderConnector;
export { VacationFinderConnector };
